module.exports = __webpack_public_path__ + "static/images/spike02-ms.2e33f0c.png";